import {rootState} from '@mintdata-wsp/common/state/RootState';
import {WSPIcons} from '@mintdata-wsp/resources/icons/WSPIcons';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {TopBarButton} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topBar/TopBarButton';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./FlowTopBarBackButton.less');
const cx = classnames.bind(styles);

@observer
export class FlowTopBarBackButton extends React.Component<any, any>
{
    private _handleClick = (event:React.MouseEvent<HTMLElement>) =>
    {
        const {sampleDesign} = rootState.ui.visualDesigner;

        if( sampleDesign && sampleDesign.canSwitchToFlow )
            controllers.ui.sampleDesign.switchToSurfaceOrSpreadSheet();
        else
            controllers.navigation.toCurrentDesign();
    };

    public render():JSX.Element
    {
        const tooltipContent = 'Back to App Editor';

        const popoverProps = {
            sourceAnchor: SourceAnchor.LeftBottom,
            popupAnchor: PopupAnchor.LeftTop
        };

        return (
            <TopBarButton
                className={cx('base')}
                iconProps={{
                    name: WSPIcons.visualDesigner.topBar.Back,
                    className: cx('icon')
                }}
                onClick={this._handleClick}
                tooltipProps={{
                    content: tooltipContent,
                    popoverProps
                }}
            />
        );
    }
}
